import { IApplicationFooterScreenModel, ScreenType } from "@nf/common";
import dynamic from "next/dynamic";

import Button from "components/Button";
import type { AppFooterProps } from "./AppFooter";

import LogoFull from "resources/app/logo-full.svg";

import styles from "./AppFooterDesktop.module.scss";

const LanguageDropdown = dynamic(
  () => import("components/LanguageDropdown/LanguageDropdown"),
  { ssr: false }
);

export const AppFooter = ({ configuration }: AppFooterProps) => {
  const footer = configuration?.Screens?.[
    ScreenType.ApplicationFooter
  ] as IApplicationFooterScreenModel;
  const components = footer?.Components;

  return (
    <div className={styles.footer}>
      <a
        href="https://www.nordiskfilm.com/"
        target="_blank"
        rel="noreferrer"
        className={styles.link}
      >
        <LogoFull className={styles.logo} />
      </a>

      <div className={styles.menu}>
        {components?.map(({ Action, Title }) =>
          Action?.Url && Title ? (
            <Button
              key={Title}
              size="small"
              variant="tertiary"
              href={Action.Url}
              rel="noreferrer"
              target="_blank"
              className={styles.menuItem}
            >
              {Title}
            </Button>
          ) : null
        )}

        <div className={styles.languages}>
          <LanguageDropdown />
        </div>
      </div>
    </div>
  );
};

export default AppFooter;
